export default "__VITE_ASSET__BPYvPCPi__"